module.exports = __webpack_public_path__ + "img/20190826133420815.bd98fca4.jpg";